module.exports = __webpack_public_path__ + "static/media/surfingann-min.22486ced.png";